import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const dataInjestValidation = () => {
    return yup.object().shape({
        subscriptionTopic: yup.string().required(ERRORS.required),
        kafkaTopic: yup.string().required(ERRORS.required),
        targetCollection: yup.string().required(ERRORS.required),
        parserFunction: yup.string().required(ERRORS.required),
        rtAlertMonitoring: yup.bool().required(ERRORS.required),
        mqttDataCompression: yup.bool().required(ERRORS.required),
        skipThrottle: yup.bool().required(ERRORS.required),
    });
};
